<template>
    <div class="modal modal-error">
         <Modal 
            @closeModalErrorOpen="closeModal"
            :title="'Niestety nie można teraz uruchomić materiału. Spróbuj ponownie później.'"
            class="modal-error__title"
        />
    </div>
</template>

<script>
import Modal from "./Modal.vue"

export default {
    name: "ModalErrorOpen",
    components: {
        Modal,
    },
    computed: {
        path() {
            return this.$route.path;
        }
    },
    watch: {
        path() {
            this.closeModal();
        }
    },   
    methods: {
        closeModal() {
            this.$store.dispatch("changeModalErrorOpenState");
            this.$store.dispatch("changeModalBackdrop", false);    
        }
    }
}
</script>
